export default __webpack_public_path__ + "static/media/How it works white.e5faca08.png";